import { EpicIcons, Button } from "@constellation-academy/epic-ui";
import { Toast } from "primereact/toast";
import React, { useContext, useRef } from "react";
import { useMutation } from "react-relay";
import { useTranslation } from "@i18n/hooks";
import { deleteMessageDefinitionButton_DeleteMessageDefinitionMutation } from "@relay/deleteMessageDefinitionButton_DeleteMessageDefinitionMutation.graphql";
import { DELETE_MESSAGE_DEFINITION_MUTATION } from "./delete-message-definition-button.graphql";
import { DeleteMessageDefinitionButtonProps } from "./delete-message-definition-button.types";
import { ButtonVariant } from "../../../../../components/button";
import { useDialogLogic } from "../../../../../hooks/use-dialog-logic";

import { MessageDefinitionsContext } from "../../../message-definitions.context";

export const DeleteMessageDefinitionButton = ({
	messageDefinitionId,
}: DeleteMessageDefinitionButtonProps) => {
	const { t } = useTranslation("common");
	const { connectionId } = useContext(MessageDefinitionsContext);
	const toast = useRef<Toast>(null);

	const { showDialog, dialogComponent } = useDialogLogic();
	const [deleteMessageDefinition, isDeletingMessageDefinition] =
		useMutation<deleteMessageDefinitionButton_DeleteMessageDefinitionMutation>(
			DELETE_MESSAGE_DEFINITION_MUTATION,
		);
	const handleOnDeleteClick = () => {
		showDialog({
			title: t("messageDefinition.deleteTitle"),
			content: t("messageDefinition.deleteConfirm"),
			dialogCallback: (result) => {
				if (result === "Accept") {
					deleteMessageDefinition({
						variables: {
							input: {
								messageDefinitionId: messageDefinitionId,
							},
							connections: [connectionId],
						},
						onCompleted: () => {
							toast.current?.show({
								severity: "success",
								life: 3000,
								summary: t("messageDefinition.deletedSummary"),
								detail: t("messageDefinition.deletedDetail"),
							});
						},
						onError: () => {
							toast.current?.show({
								severity: "error",
								life: 3000,
								summary: t("messageDefinition.deleteErrorSummary"),
								detail: t("messageDefinition.deleteErrorDetail"),
							});
						},
					});
				}
			},
		});
	};

	return (
		<>
			<Toast ref={toast}></Toast>
			{dialogComponent}
			<Button
				disabled={isDeletingMessageDefinition}
				icon={EpicIcons.TRASH}
				variant={ButtonVariant.Error}
				onClick={handleOnDeleteClick}
			/>
		</>
	);
};
